module.exports = __webpack_public_path__ + "img/arrow-down.522b6029.svg";